<template>
  <div class="pg-icon-selected" :id="idPrefix">
    <i
      v-if="!checked"
      :class="['el-icon-circle-plus-outline', { 'pg-icon-selected_disabled': disabled }]"
    ></i>
    <i
      v-if="checked"
      :class="['el-icon-remove-outline', { 'pg-icon-selected_disabled': disabled }]"
    ></i>
  </div>
</template>
<script setup>
// vue
import { computed } from 'vue'

const props = defineProps({
  idPrefix: String,
  value: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})

const checked = computed(() => props.value)
const disabled = computed(() => props.disabled)
</script>
<style lang="scss">
@import '../style/icon-selected.scss';
</style>
